
import Background from "../img/cover.jpg";
import Logo from "../img/logo-k.png";
import React, { Fragment, Component } from 'react';

export default () => (
	<div>
		<div style={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			height: '70vh',
		}}>

			<div className="landing-cover__logo">

				<div className="landing-cover__logo__img">
					<img
						src={Logo}
						style={{
							minWidth: '150px',
						}}
					></img>
				</div>

			</div>


			<div className="landing-cover__title">
				<div className="landing-cover__logo-mobile">
					<img
						src={Logo}
						style={{
							width: '70px',
						}}
					></img>
				</div>
				<h1 style={{ color: 'white' }}>Việt phố   </h1>
				{/* <h3 style={{display:'inline'}}><i style={{lineHeight:'2'}} className="fa fa-volume-up" aria-hidden="true" ></i></h3> */}
				<h1 style={{ color: 'white', lineHeight: '4rem' }}> \’viə̰ʔt˨˩ fo˧˥’\ </h1>

				<p>Auf Deutsch die Straßen Vietnams. Dort ist Streetfood kein Trend sondern Kultur und Alltag. Ob in den Mittagspausen oder Abends mit Freunden oder der Familie, auf den Straßen wird gegessen. Mit Vietpho Cuisine bringen wir den unverfälschten Geschamk dieser Mainstream-Esskultur unseren Deutschen Gästen ein Stück näher. </p>

				<ul className="icons">

					<li><a style={{ color: 'white' }} href="https://www.facebook.com/VietPho-Cuisine-334073757070790/" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
					<li><a style={{ color: 'white' }} href="https://www.instagram.com/vietpho_cuisine/" className="icon fa-instagram"><span className="label">Instagram</span></a></li>

				</ul>

			</div>


		</div>

		{/* <Scroller></Scroller> */}
	</div>
)



// WEBPACK FOOTER //
// ./src/pages/index.js